import { Typography } from '@mui/material';
import { HeaderContainer } from '../dashboard/AgentInfoHeader';
import { FC } from 'react';

const BillingHeader: FC = () => {
  return (
    <HeaderContainer>
      <Typography
        sx={{
          fontFamily: 'DM Sans',
          fontWeight: 600,
          fontSize: '24px',
          lineHeight: '100%',
          letterSpacing: '-0.01em',
          color: '#2B2D3F',
        }}
      >
        Billing & Invoicing
      </Typography>
    </HeaderContainer>
  );
};

export default BillingHeader;
